import { useState } from 'react'
import { toaster } from '../components/ui/toaster'
import { downloadVideo } from '../services/videoDownload'
import { useTranslation } from '../i18n'

/**
 * Save a video to disk, with its progress. Behind `DownloadButton`, and used
 * directly wherever the download is a menu item rather than a button.
 * `source` / `url` are as documented on DownloadButton.
 * @returns {{status: ?string, busy: boolean, start: function(?Event): Promise<void>}}
 *   status is null, 'preparing' or 'downloading'.
 */
export function useVideoDownload({ url, source, fileName, onDone }) {
    const { t } = useTranslation()
    const [status, setStatus] = useState(null)
    const busy = status !== null

    const start = async (e) => {
        e?.stopPropagation?.()
        if (busy || (!url && !source)) return
        setStatus('downloading')
        try {
            await downloadVideo({ source, url, fileName, onStatus: setStatus })
            onDone?.()
        } catch (err) {
            console.error('Download failed:', err)
            toaster.create({ title: t('common.downloadFailed'), type: 'error' })
        } finally {
            setStatus(null)
        }
    }

    return { status, busy, start }
}
